// hemēka — précharge les photos un peu avant qu'on les atteigne.
// Safari sur iPhone n'anticipe presque pas les images « loading=lazy » (surtout dans les rangées
// qui défilent de côté, ex. « Souvent pris avec ») : elles n'apparaissaient qu'une fois à l'écran
// (retour de Davy, 18/10). On passe donc en « eager » les images d'une section dès qu'elle arrive
// à 1 500 px de l'écran, et celles des blocs ajoutés ensuite (recommandations, suggestions du panier).
// 22/10 : avant, TOUTES les images de la page partaient au chargement (2,7 Mo sur l'accueil) ; et une
// image « eager » ignore sizes="auto" (cartes Horizon) → le navigateur prenait 100vw (832 à 1 600 px
// pour une vignette de 150 px). On écrit donc la largeur réellement affichée avant de passer en eager.
(() => {
  const zone = () => document.querySelector('main') || document.body;
  const precharger = (racine) => {
    if (!racine || !racine.querySelectorAll) return;
    racine.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      const largeur = img.getBoundingClientRect().width;
      if (!largeur) return; // image cachée (diapositive masquée, onglet fermé) : on la laisse au navigateur
      if (/^\s*auto/.test(img.getAttribute('sizes') || '')) img.sizes = `${Math.ceil(largeur)}px`;
      img.loading = 'eager';
    });
  };
  const demarrer = () => {
    const racine = zone();
    const sections = racine.querySelectorAll(':scope > *');
    if ('IntersectionObserver' in window && sections.length) {
      const obs = new IntersectionObserver((entrees) => entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        precharger(e.target);
        obs.unobserve(e.target);
      }), { rootMargin: '1500px 0px' });
      sections.forEach((s) => obs.observe(s));
    } else {
      precharger(racine);
    }
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((n) => precharger(n)));
    }).observe(racine, { childList: true, subtree: true });
  };
  const apres = () => (window.requestIdleCallback ? requestIdleCallback(demarrer, { timeout: 1500 }) : setTimeout(demarrer, 300));
  if (document.readyState === 'complete') apres();
  else window.addEventListener('load', apres, { once: true });
})();
